__turbopack_context__.v({
  "actions": "ActionPlanPendingCard-module__qEwq4G__actions",
  "addMoTa": "ActionPlanPendingCard-module__qEwq4G__addMoTa",
  "assignee": "ActionPlanPendingCard-module__qEwq4G__assignee",
  "assigneeAvatar": "ActionPlanPendingCard-module__qEwq4G__assigneeAvatar",
  "assigneeInline": "ActionPlanPendingCard-module__qEwq4G__assigneeInline",
  "assigneeMeta": "ActionPlanPendingCard-module__qEwq4G__assigneeMeta",
  "assigneeMissing": "ActionPlanPendingCard-module__qEwq4G__assigneeMissing",
  "assigneeName": "ActionPlanPendingCard-module__qEwq4G__assigneeName",
  "assigneeText": "ActionPlanPendingCard-module__qEwq4G__assigneeText",
  "card": "ActionPlanPendingCard-module__qEwq4G__card",
  "changeKey": "ActionPlanPendingCard-module__qEwq4G__changeKey",
  "changes": "ActionPlanPendingCard-module__qEwq4G__changes",
  "chip": "ActionPlanPendingCard-module__qEwq4G__chip",
  "chipKey": "ActionPlanPendingCard-module__qEwq4G__chipKey",
  "chips": "ActionPlanPendingCard-module__qEwq4G__chips",
  "compactForm": "ActionPlanPendingCard-module__qEwq4G__compactForm",
  "fact": "ActionPlanPendingCard-module__qEwq4G__fact",
  "factAction": "ActionPlanPendingCard-module__qEwq4G__factAction",
  "factItem": "ActionPlanPendingCard-module__qEwq4G__factItem",
  "factKey": "ActionPlanPendingCard-module__qEwq4G__factKey",
  "factVal": "ActionPlanPendingCard-module__qEwq4G__factVal",
  "facts": "ActionPlanPendingCard-module__qEwq4G__facts",
  "grid2": "ActionPlanPendingCard-module__qEwq4G__grid2",
  "headIcon": "ActionPlanPendingCard-module__qEwq4G__headIcon",
  "headIconDanger": "ActionPlanPendingCard-module__qEwq4G__headIconDanger",
  "headTitle": "ActionPlanPendingCard-module__qEwq4G__headTitle",
  "moTa": "ActionPlanPendingCard-module__qEwq4G__moTa",
  "quick": "ActionPlanPendingCard-module__qEwq4G__quick",
  "scope": "ActionPlanPendingCard-module__qEwq4G__scope",
  "scopeTag": "ActionPlanPendingCard-module__qEwq4G__scopeTag",
  "summary": "ActionPlanPendingCard-module__qEwq4G__summary",
  "titleEdit": "ActionPlanPendingCard-module__qEwq4G__titleEdit",
  "titleInput": "ActionPlanPendingCard-module__qEwq4G__titleInput",
  "titleItem": "ActionPlanPendingCard-module__qEwq4G__titleItem",
  "titleRow": "ActionPlanPendingCard-module__qEwq4G__titleRow",
});
